import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { FileDrop } from '../../components/FileDrop';
import baseURL from '../../config/api';
import { getSubGroup, put_SubGroup } from '../../services/SubGroup';
import { formatUSPhone, handleUSPhoneChange } from '../../utils/phoneFormatter';
import { useUSPhoneValidation } from '../../hook/useUSPhoneValidation';
import useGroup from '../../hook/useGroup';
import useSubGroup from '../../hook/useSubGroup';
import EmailFormatValidation from '../../components/EmailFormatValidation';
import Cookies from 'js-cookie';

const EditSubGroup = () => {
  const token = Cookies.get("token-my-cdir");
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const { selectedGroupId }: any = useGroup();
  const { setRefreshTheSubGroup }: any = useSubGroup();
  const [subGroupData, setSubGroupData] = useState<any>({
    name: "",
    discription: "",
    firstName: "",
    lastName: "",
    emailAddress: "",
    phoneNumber: "",
    imagePath: "",
    street: "",
    street2: "",
    city: "",
    state: "",
    country: "",
    zip: "",
    isActive: "",
    groupId: 0,
  });
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const {
    isValid: isPhoneValid,
    touched: phoneTouched,
    setTouched: setPhoneTouched
  } = useUSPhoneValidation(subGroupData.phoneNumber);

  useEffect(() => {
    if (id) {
      getSubGroup(id, token!.toString())
        .then(res => {
          setSubGroupData({
            ...res,
            imagePath: res?.imagePath ? res.imagePath : ""
          });
        })
        .catch(error => console.error(error));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, location])

  const closeModal = () => navigate(-1);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (isProcessing) return;

    setIsProcessing(true);

    try {
      await put_SubGroup({
        ...subGroupData,
        groupId: selectedGroupId,
        imagePath: subGroupData?.imagePath?.replace(
          `${baseURL}commonFile/Get?name=`,
          ""
        )
      }, token!.toString());

      setRefreshTheSubGroup(true);
      navigate(-1);
    } catch (err) {
      console.error(err);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div className="w-full">
      <div className="my-2">
        <div className="mx-auto max-w-6xl  relative bg-white">
          <h2 className="text-xl text-secondary font-bold">Edit Ministry</h2>
          <form onSubmit={handleSubmit} className="mt-8 grid xm:grid-cols-2 gap-6 text-secondary">
            <div>
              <label className="font-semibold text-sm">Ministry Name</label>
              <input type='text' placeholder='Enter Ministry Name'
                className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary"
                value={subGroupData.name}
                onChange={(e) => setSubGroupData({ ...subGroupData, name: e.target.value })}
                required
              />
            </div>

            <div />

            <div>
              <label className="font-semibold text-sm">First Name</label>
              <input type='text' placeholder='Enter First Name'
                className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary"
                value={subGroupData.firstName}
                onChange={(e) => setSubGroupData({ ...subGroupData, firstName: e.target.value })}
                required
              />
            </div>
            <div>
              <label className="font-semibold text-sm">Last Name</label>
              <input type='text' placeholder='Enter Last Name'
                className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary"
                value={subGroupData.lastName}
                onChange={(e) => setSubGroupData({ ...subGroupData, lastName: e.target.value })}
                required
              />
            </div>

            <EmailFormatValidation
              text={subGroupData.emailAddress}
              setText={(value) =>
                setSubGroupData({
                  ...subGroupData,
                  emailAddress: value
                })
              }
              className={{
                parentDiv: "",
                label: "font-semibold text-sm",
                input:
                  "w-full rounded py-2.5 px-4 border-2 mt-2 text-sm text-black outline-secondary"
              }}
              required
            />

            <div>
              <label className="font-semibold text-sm">Phone Number</label>
              <input
                type="tel"
                name="phone"
                value={formatUSPhone(subGroupData.phoneNumber)}
                onChange={(e) => {
                  setPhoneTouched(true);
                  handleUSPhoneChange(e, (digits) =>
                    setSubGroupData((prev: any) => ({
                      ...prev,
                      phoneNumber: digits,
                    }))
                  );
                }}
                className="w-full rounded py-2.5 px-4 border-2 mt-2 text-sm text-black outline-secondary"
                placeholder="Phone No."
              />

              {!isPhoneValid && phoneTouched && (
                <p className="text-xs text-red-500 mt-1">
                  Please enter a valid 10-digit phone number
                </p>
              )}
            </div>
            <div>
              <label className="font-semibold text-sm">Street</label>
              <input type='text' placeholder='Street'
                className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary"
                value={subGroupData.street}
                onChange={(e) => setSubGroupData({ ...subGroupData, street: e.target.value })}
                required
              />
            </div>
            <div>
              <label className="font-semibold text-sm">Street 2</label>
              <input type='text' placeholder='Street 2'
                className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary"
                value={subGroupData.street2}
                onChange={(e) => setSubGroupData({ ...subGroupData, street2: e.target.value })}
              />
            </div>
            <div>
              <label className="font-semibold text-sm">City</label>
              <input type='text' placeholder='City'
                className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary"
                value={subGroupData.city}
                onChange={(e) => setSubGroupData({ ...subGroupData, city: e.target.value })}
              />
            </div>
            <div>
              <label className="font-semibold text-sm">State</label>
              <input type='text' placeholder='State'
                className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary"
                value={subGroupData.state}
                onChange={(e) => setSubGroupData({ ...subGroupData, state: e.target.value })}
                required
              />
            </div>
            <div>
              <label className="font-semibold text-sm">Country</label>
              <input type='text' placeholder='Country'
                className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary"
                value={subGroupData.country}
                onChange={(e) => setSubGroupData({ ...subGroupData, country: e.target.value })}
              />
            </div>
            <div>
              <label className="font-semibold text-sm">Zip</label>
              <input type='text' placeholder='Zip'
                className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary"
                value={subGroupData.zip}
                onChange={(e) => setSubGroupData({ ...subGroupData, zip: e.target.value })}
                required
              />
            </div>

            <div className='h-5/6'>
              <label className="font-semibold text-sm">Description</label>
              <textarea placeholder='Enter Description'
                className="w-full h-full rounded py-2.5 px-4 mt-3 border-2 text-sm text-black outline-secondary"
                value={subGroupData.discription}
                onChange={(e) => setSubGroupData({ ...subGroupData, discription: e.target.value })}
              />
            </div>
            <div>
              <label htmlFor="active" className="font-semibold text-sm">
                Active?
              </label>{" "}
              <div className="flex flex-row">
                <div className="flex items-center mr-2">
                  <input
                    type="radio"
                    value="Yes"
                    name="active"
                    style={{ fontSize: "12px" }}
                    checked={subGroupData.isActive ? true : false}
                    onChange={(e) => setSubGroupData({ ...subGroupData, isActive: e.target.value === "Yes" ? true : false })}
                  />
                  <label className="ml-1">Yes</label>
                </div>
                <div className="flex items-center">
                  <input
                    type="radio"
                    value="No"
                    name="active"
                    style={{ fontSize: "12px" }}
                    checked={subGroupData.isActive ? false : true}
                    onChange={(e) => setSubGroupData({ ...subGroupData, isActive: e.target.value === "Yes" ? true : false })}
                  />
                  <label className="ml-1">No</label>
                </div>
              </div>
            </div>

            <div className='h-2/5 mt-4'>
              <FileDrop
                value={subGroupData.imagePath}
                setValue={(value) => setSubGroupData({ ...subGroupData, imagePath: value })}
              />
            </div>
            <div />

            <div className="flex max-xm:flex-col gap-4 !mt-4">
              <button
                type="button"
                className="px-6 py-2 min-w-[150px] rounded text-black text-sm font-semibold border-none outline-none bg-gray-200 hover:bg-gray-300 active:bg-gray-200"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-6 py-2 min-w-[150px] rounded text-white text-sm font-semibold border-none outline-none bg-secondary hover:bg-custom-blue"
              >
                {isProcessing ?
                  <>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18px" fill="#fff" className="mr-2 inline animate-spin"
                      viewBox="0 0 26.349 26.35">
                      <circle cx="13.792" cy="3.082" r="3.082" data-original="#000000" />
                      <circle cx="13.792" cy="24.501" r="1.849" data-original="#000000" />
                      <circle cx="6.219" cy="6.218" r="2.774" data-original="#000000" />
                      <circle cx="21.365" cy="21.363" r="1.541" data-original="#000000" />
                      <circle cx="3.082" cy="13.792" r="2.465" data-original="#000000" />
                      <circle cx="24.501" cy="13.791" r="1.232" data-original="#000000" />
                      <path
                        d="M4.694 19.84a2.155 2.155 0 0 0 0 3.05 2.155 2.155 0 0 0 3.05 0 2.155 2.155 0 0 0 0-3.05 2.146 2.146 0 0 0-3.05 0z"
                        data-original="#000000" />
                      <circle cx="21.364" cy="6.218" r=".924" data-original="#000000" />
                    </svg>
                    Processing...
                  </>
                  :
                  "Save"
                }
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default EditSubGroup